import moment from "moment";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { _TAKA_ } from "../../constants";

const TopupCard = ({ topup, setAlert, setAlertStatusUpdate }) => {

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        return toast.success('Copied to clipboard!', {position: 'bottom-center', className: 'backdrop-filter backdrop-blur-lg bg-opacity-20',id: 'clipboard',});
    }

    return (
        <div className="w-full px-4 py-3 bg-blue-400 rounded-xl shadow-lg hover:shadow-xl transform transition duration-500 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden">
            <div className="flex justify-center items-center">
                {/* <span className="p-2 bg-gray-400 rounded-full"></span> */}

                <div className="w-full items-center justify-between">
                    <div>
                        <span className="bg-gray-500 px-2 py-1 rounded-full backdrop-filter bg-opacity-20 overflow-hidden uppercase text-xs text-gray-300">{moment(topup.createdAt.toDate().toString()).fromNow()}</span>
                    </div>
                    <div className="text-gray-200 text-2xl truncate">
                        {topup.price} <span className="text-3xl">{_TAKA_}</span>
                        <span className="px-2">-</span>
                        <span className="text-gray-200 text-2xl">{topup.diamond}</span>
                    </div>
                    {/* <div className="text-gray-200 text-sm">{topup.paymentMethod} - {topup.paymentNumber}</div> */}
                </div>


                <Link to={"/topup/" + topup.uid}><span className="material-icons-outlined p-2 bg-blue-400 text-gray-400 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden">navigate_next</span></Link>
            </div>

            <div className="flex justify-center rounded-full mt-2">
                <button 
                    // onClick={() => handleTopupStatus(index, 'pending')} 
                    onClick={() => setAlertStatusUpdate({isloading: false, show: true, id: topup.uid, status: 'pending'})}
                    className={topup.status === 'pending' ? "text-xs bg-blue-500 uppercase text-yellow-400 hover:bg-blue-500 hover:text-white rounded-l-full px-3 py-0 mx-0 backdrop-filter bg-opacity-20" : "text-xs bg-blue-500 text-gray-400 uppercase hover:bg-blue-500 hover:text-white bg-blue-500 rounded-l-full px-3 py-0 mx-0 backdrop-filter bg-opacity-20"}
                    >Pending</button>
                <button 
                    // onClick={() => handleTopupStatus(index, 'processing')} 
                    onClick={() => setAlertStatusUpdate({isloading: false, show: true, id: topup.uid, status: 'processing'})}
                    className={topup.status === 'processing' ? "text-xs bg-blue-500 uppercase text-yellow-400 hover:bg-blue-500 hover:text-white px-3 py-0 mx-0 backdrop-filter bg-opacity-20" : "text-xs bg-blue-500 text-gray-400 uppercase hover:bg-blue-500 hover:text-white bg-blue-500 px-3 py-0 mx-0 backdrop-filter bg-opacity-20"}
                    >Processing</button>
                <button 
                    // onClick={() => handleTopupStatus(index, 'canceled')} 
                    onClick={() => setAlertStatusUpdate({isloading: false, show: true, id: topup.uid, status: 'canceled'})}
                    className={topup.status === 'canceled' ? "text-xs bg-blue-500 uppercase text-red-400 hover:bg-blue-500 hover:text-white px-3 py-0 mx-0 backdrop-filter bg-opacity-20" : "text-xs bg-blue-500 text-gray-400 uppercase hover:bg-blue-500 hover:text-white bg-blue-500 px-3 py-0 mx-0 backdrop-filter bg-opacity-20"}
                    >Canceled</button>
                <button 
                    // onClick={() => handleTopupStatus(index, 'done')} 
                    onClick={() => setAlertStatusUpdate({isloading: false, show: true, id: topup.uid, status: 'done'})}
                    className={topup.status === 'done' ? "text-xs bg-blue-500 uppercase text-green-400 hover:bg-blue-500 hover:text-white px-3 py-0 mx-0 backdrop-filter bg-opacity-20" : "text-xs bg-blue-500 text-gray-400 uppercase hover:bg-blue-500 hover:text-white bg-blue-500 px-3 py-0 mx-0 backdrop-filter bg-opacity-20"}
                    >Done</button>
                <button 
                    // onClick={() => handleTopupStatus(index, 'done')}  
                    onClick={() => setAlert({ show: true, isloading:false, id: topup.uid })} 
                    className="text-xs bg-red-500 text-gray-400 rounded-r-full uppercase px-2 py-0 mx-0 backdrop-filter bg-opacity-60"
                    ><span className="">delete</span></button>
            </div>
        </div>
    );

}

export default TopupCard;